{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/pattern",
	"title": "Pattern Placeholder",
	"category": "theme",
	"description": "Show a block pattern.",
	"supports": {
		"html": false,
		"inserter": false,
		"renaming": false,
		"visibility": false,
		"interactivity": {
			"clientNavigation": true
		}
	},
	"textdomain": "default",
	"attributes": {
		"slug": {
			"type": "string"
		}
	}
}
